module.exports = __webpack_public_path__ + "static/logo-svg-87d9f8b9f22c81d24d49d7000e9912c5.svg";